/* One height range for every dialog in the app (confirmations and error
   dialogs excepted: they fit their message). The panel is a flex column as
   tall as its content, never shorter than the minimum and never taller than
   the maximum; its header and footer are flex-none and its body scrolls
   (`min-h-0 flex-1 overflow-y-auto`), so a dialog with one item keeps the
   minimum and a long one scrolls inside the maximum. */
export const DIALOG_HEIGHT = "min-h-[40vh] max-h-[85vh]";
